import { render } from "./Groups.vue?vue&type=template&id=693776ba&scoped=true"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"

import "./Groups.vue?vue&type=style&index=0&id=693776ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693776ba"]])

export default __exports__